import { render, staticRenderFns } from "./UnpaidInvoice.vue?vue&type=template&id=2f57774c&"
import script from "./UnpaidInvoice.vue?vue&type=script&lang=js&"
export * from "./UnpaidInvoice.vue?vue&type=script&lang=js&"
import style0 from "./UnpaidInvoice.vue?vue&type=style&index=0&id=2f57774c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports